export default __webpack_public_path__ + "look_for_target.svg";